<template>
  <div>
    <search-bar @search="doSearch" @clear="doClear" :full-width="true" :query="mode.search.q" :doing="mode.search.doing"></search-bar>
    <panel title="Agencies" :footerShow="true">
      <div slot="headingElements">
        <a class="btn btn-success" @click="addItemClick()"><i class="icon-add"></i> <span class="text-semibold">Add agency</span></a>
      </div>
      <div>
        <div ref="list" class="datatable-scroll scrollable">
          <table class="dataTable table table-hover tasks-list text-nowrap" role="grid">
            <thead>
            <tr role="row">
              <th style="width: 1px;"></th>
              <th tabindex="0" rowspan="1" colspan="1" data-sort-field="id" @click.prevent="toggleSort" style="width: 20px;">#</th>
              <th tabindex="0" rowspan="1" colspan="1" data-sort-field="name" @click.prevent="toggleSort">Name</th>
              <th tabindex="0" rowspan="1" colspan="1" data-sort-field="country" @click.prevent="toggleSort" data-hide="phone,tablet">Country</th>
              <th tabindex="0" rowspan="1" colspan="1" data-sort-field="city" @click.prevent="toggleSort" data-hide="phone,tablet">City</th>
              <th tabindex="0" rowspan="1" colspan="1" data-sort-field="director_name" @click.prevent="toggleSort" data-hide="phone,tablet">Director</th>
              <th tabindex="0" rowspan="1" colspan="1" data-sort-field="email" @click.prevent="toggleSort">Email</th>
              <th tabindex="0" rowspan="1" colspan="1" data-sort-field="phone" @click.prevent="toggleSort">Phone</th>
              <th style="width: 1px;"></th>
            </tr>
            </thead>
            <tbody>
            <tr v-if="!items.length" class="active border-double">
              <td colspan="8" class="text-semibold text-center">No data available</td>
            </tr>
            <template v-for="(item, idx) in items">
              <tr :key="item.id" role="row" class="border-top-dashed-2px" v-bind:class="{'even': idx === 0 || idx % 2 === 0, 'odd': idx % 2}">
                <td>
                  <template v-if="item.subitems && item.subitems.length">
                    <ul class="icons-list">
                      <li><a @click.prevent="toggleSubitems($event, item.id)"><i :class="{'icon-minus2': item.expanded, 'icon-plus2': !item.expanded}"></i></a></li>
                    </ul>
                  </template>
                </td>
                <td class="">
                  <a href="#" @click.prevent="editItem(item.id)">#{{item.id | formatID}}</a>
                </td>
                <td>
                  <div class="text-semibold">{{item.name}}</div>
                </td>
                <td>
                  <div class="text-semibold">{{item.country}}</div>
                </td>
                <td>
                  <div class="text-semibold">{{item.city}}</div>
                </td>
                <td>
                  <div class="text-semibold">{{item.director_name}}</div>
                </td>
                <td>
                  <div class="text-semibold">{{item.email}}</div>
                </td>
                <td>
                  <div class="text-semibold">{{item.phone}}</div>
                </td>
                <td>
                  <ul class="icons-list">
                    <li><a href="#" @click.prevent="editItem(item.id)" title="Update agency"><i class="icon-pencil"></i></a></li>
                    <li><a href="#" @click.prevent="deleteItem(item.id)" title="Delete agency"><i class="icon-trash"></i></a></li>
                    <li><a href="#" @click.prevent="addItemClick(item.id)" title="Add sub-agency"><i class="icon-redo rotate-90"></i></a></li>
                  </ul>
                </td>
              </tr>
              <template v-if="item.subitems && item.subitems.length">
                <tr class="subheader collapsed bg-success-300" :data-parent="item.id" v-show="item.expanded">
                  <td colspan="9" class="pl-20">Sub-agencies</td>
                </tr>
                <tr v-for="(subitem, sidx) in item.subitems" :key="sidx" class="subrow collapsed success" :data-parent="item.id" v-show="item.expanded">
                  <td></td>
                  <td class=""><a href="#" @click.prevent="editItem(subitem.id)">#{{subitem.id | formatID}}</a></td>
                  <td>
                    <div class="text-semibold">{{subitem.name}}</div>
                  </td>
                  <td>
                    <div class="text-semibold">{{subitem.country}}</div>
                  </td>
                  <td>
                    <div class="text-semibold">{{subitem.city}}</div>
                  </td>
                  <td>
                    <div class="text-semibold">{{subitem.director_name}}</div>
                  </td>
                  <td>
                    <div class="text-semibold">{{subitem.email}}</div>
                  </td>
                  <td>
                    <div class="text-semibold">{{subitem.phone}}</div>
                  </td>
                  <td>
                    <ul class="icons-list">
                      <li><a href="#" @click.prevent="editItem(subitem.id)" title="Update sub-agency"><i class="icon-pencil"></i></a></li>
                      <li><a href="#" @click.prevent="deleteItem(subitem.id)" title="Delete sub-agency"><i class="icon-trash"></i></a></li>
                    </ul>
                  </td>
                </tr>
              </template>
            </template>
            </tbody>
          </table>
        </div>
      </div>
      <div slot="footerElements">
        <div class="col-sm-12">
          <pagination :page="paging.page" :itemsPerPage="paging.perPage" :maxVisiblePage="5" :totalItems="paging.total" @page-change="__pageChanged"/>
        </div>
      </div>
    </panel>
    <overlay v-if="showLoader" message="Please wait..." html="<i class='icon-spinner2 icon-2x spinner'></i>"></overlay>
  </div>
</template>

<script>

import Vue from 'vue'

import AgencyService from '@/services/agency.service'

import listMixin from '@/helpers/mixins/_listMixin'
import SearchBar from '../_partial/search-bar'

export default {
  components: {SearchBar},
  name: 'AgencyIndex',
  mixins: [listMixin],

  data () {
    return {
      id: null,
      itemTemplate: {
        showModal: false
      },
      service: AgencyService
    }
  },

  mounted () {
  },

  methods: {
    reset (forceItemsReset = true) {
      this.id = null
      this.groupStatuses = Vue.config.statusGroups['agency'] ? Vue.config.statusGroups['agency'] : Vue.config.statusGroups['*']
      for (let i = 0; i < this.groupStatuses.length; i++) {
        this.statuses.push(this.systemStatuses[this.groupStatuses[i]])
      }
    },

    editItem (id) {
      this.$router.push('agency/details/' + id)
    },

    deleteItem (id) {
      this.$popup.confirm('Are you sure you want to remove this agency?', 'Agency delete').then(() => {
        // let item = this.getById(id)
        // if (item && item.userAgencies && item.userAgencies.length) {
        //  this.$popup.
        // } else {
        this.service.drop(id, (result) => {
          this.refresh()
        })
        // }
      })
    },

    updateItemRow (i) {
      this.service.item(i.id, result => {
        i.status = result.status
        i.updated_at = result.updated_at
      })
    },

    addItemClick (parentId) {
      this.$router.push({name: 'agency.create', params: {parentId: parentId}})
    },

    canBeChanged (object) {
      let result = typeof object === 'object'
      if (result) {
        result = result && object.hasOwnProperty('id') && object.id
      }
      result = result && object.status === 1
      return result
    }
  }
}
</script>

<style scoped>
</style>
